import { useRef } from "react";
import { Button } from "antd";
import { toast } from "react-toastify";
import { Modal } from "ui";
import { useArticleManagementStore } from "pages/articles/store";
import { useAddArticle, useUpdateArticle } from "pages/articles/api";
import { articleForm } from "pages/articles/type";
import ArticleBaseForm, {
  ArticleFormRef,
} from "pages/articles/components/article-sections/tabs/base-tab/form";
import { isObjectEmpty } from "core/utils/json-utils";

const ArticlesModal = () => {
  const { setFormData, formData } = useArticleManagementStore((state) => state);

  const { mutate, isPending } = useAddArticle();

  const formRef = useRef<ArticleFormRef>(null);

  const handleOk = (onSuccess: () => void) => {
    if (!formRef.current) return;

    // Get validation and form values
    const { validation, values } = formRef.current.getFormData();
    validation.then((result) => {
      // If no errors, then data is valid
      if (isObjectEmpty(result)) {
        if (!values?.uploadImage) {
          toast.error("لطفا تصویر مقاله را مشخص کنید");
          return;
        }

        mutate(
          {
            data: values!,
          },
          {
            onSuccess: () => {
              formRef.current?.resetForm();
              onSuccess();
            },
          }
        );
      }
    });
  };

  return (
    <Modal
      name="ARTICLE_MANAGEMENT_MODAL"
      title="افزودن مقاله جدید"
      okButtonProps={{
        loading: isPending,
      }}
      onClose={() => {
        setFormData(undefined);
        formRef.current?.resetForm();
      }}
      footer={(cancel, ok) => (
        <>
          <Button
            onClick={() => {
              cancel();
            }}
          >
            لغو
          </Button>
          <Button
            loading={isPending}
            type="primary"
            onClick={() => {
              handleOk(ok);
            }}
          >
            ثبت
          </Button>
        </>
      )}
    >
      <ArticleBaseForm
        ref={formRef}
        formData={formData as articleForm}
        isEdit={false}
      />
    </Modal>
  );
};
export default ArticlesModal;
